/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  Stack,
  HStack,
  Text,
  Spinner,
  VStack,
  Image,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardPostBox } from 'v4/snippets/dashboard/feed/post-box';
import { SearchContext } from '../../context';
import { SearchCardSkeleton } from '../../search-card-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const SearchEventsListing = forwardRef(
  ({ count = 0, listing, isMainList=false,fromPublic=false, ...props }, ref) => {
    const {
      eventsSearchListing,
      refetchEventsSearch,
      search,
      activeTab,
      eventsSearchIsFetching,
      eventsFetchNextPage,
      eventsHasNextPage,
      eventsTotalCount,
    } = useContext(SearchContext);

    useEffect(() => {
      if (!listing && activeTab === 'events' && !isMainList) {
        refetchEventsSearch?.();
      }
    }, [search, listing, activeTab]);
    const { t } = useTranslator();
    const list = listing ?? eventsSearchListing;

    return (
      <Stack w="100%" mt={0} spacing={4}>
        {eventsSearchIsFetching ? <SearchCardSkeleton /> : ''}
        {isMainList ? (
          <>
            <Card
              border="none"
              boxShadow="none"
              borderColor="brandGray.200"
              flex={1}
              p={4}
              // pl={0}
            >
              {list?.map?.((li, liIndex) => (
                <DashboardPostBox
                  key={liIndex}
                  post={li}
                  mb={4}
                  fromPublicEvent={fromPublic}
                />
              ))}
            </Card>
          </>
        ) : (
          <>
            {eventsTotalCount > 0 ? (
              <InfiniteScroll
                dataLength={list?.length}
                next={eventsFetchNextPage}
                hasMore={eventsHasNextPage}
                loader={
                  <HStack p={4} justifyContent="center" w="100%">
                    <Spinner />
                  </HStack>
                }
              >
                <Card
                  border="1px solid"
                  borderColor="brandGray.200"
                  flex={1}
                  p={4}
                  mb={3}
                  boxShadow="none"
                  mx={"auto"}
                  // pl={isMobile&&fromPublic?"8px":"0px"}
                >
                  {list?.map?.((li, liIndex) => (
                    <DashboardPostBox
                      key={liIndex}
                      post={li}
                      mb={4}
                      fromPublicEvent={fromPublic}
                    />
                  ))}
                </Card>
              </InfiniteScroll>
            ) : (
              <VStack
                justifyContent="center"
                alignItems="center"
                h="calc(80vh - 64px)"
              >
                <Image
                  src="/images/defaultSearchImage.svg"
                  alt="default Image"
                  width={["80%", "400px"]}
                />
                <Text fontSize="18px" color="#AFAFAF" fontWeight="500">
                  {t('searchPage.noResultsFound') || "No results found"}
                </Text>
                <Text fontSize="14px" color="#AFAFAF" fontWeight="500">
                  {t('searchPage.tryRephrasing') || "Try shortening or rephrasing your search."}
                </Text>
              </VStack>
            )}
          </>
        )}
      </Stack>
    );
  }
);
